/**
 * Collection Upsell — scroll-linked stack translate (Framer useScroll parity)
 * Works on mobile + desktop. Progress is measured against [data-cl-up-scroller].
 */
(function () {
  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initSection(root) {
    if (!root || root.dataset.vgClUpInit) return;
    root.dataset.vgClUpInit = '1';

    var scroller = root.querySelector('[data-cl-up-scroller]') || root;
    var track = root.querySelector('[data-cl-up-track]');
    if (!track) return;

    var count = parseInt(root.getAttribute('data-count') || '3', 10);
    var cardVh = parseFloat(root.getAttribute('data-card-vh') || '86');
    var gapVh = parseFloat(root.getAttribute('data-gap-vh') || '1');
    /* Align last card bottom with sticky frame — no empty space below */
    var advanceVh = (count - 1) * (cardVh + gapVh) - (100 - cardVh);
    if (advanceVh < 0) advanceVh = 0;

    function onScroll() {
      if (prefersReducedMotion()) {
        track.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      var rect = scroller.getBoundingClientRect();
      var total = scroller.offsetHeight - window.innerHeight;
      if (total <= 0) {
        track.style.transform = 'translate3d(0, 0, 0)';
        return;
      }

      var progress = Math.min(1, Math.max(0, -rect.top / total));
      var y = -(advanceVh * progress);
      track.style.transform = 'translate3d(0, ' + y + 'vh, 0)';
    }

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    root._vgClUpOnScroll = onScroll;
  }

  function boot() {
    document.querySelectorAll('[data-section-type="collection-upsell-new"]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    var root =
      evt.target &&
      (evt.target.querySelector
        ? evt.target.querySelector('[data-section-type="collection-upsell-new"]')
        : null);
    if (!root && evt.target && evt.target.matches) {
      root = evt.target.matches('[data-section-type="collection-upsell-new"]') ? evt.target : null;
    }
    if (root) {
      delete root.dataset.vgClUpInit;
      initSection(root);
    }
  });
})();
